


























































import { Vue, Component, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import { signOut } from 'src/boot/auth'

@Component({
  components: {
    PersonAvatar,
    DialogFullscreen
  }
})
export default class AccountPersonAvatar extends Vue {
  state = store.state

  @Ref()
  readonly dialog!: DialogFullscreen

  goToAttendee () {
    this.dialog.hide()
    store.setProfile('ATTENDEE')
    this.$route.name !== 'attendee' && this.$router.replace('/attendee/')
  }

  goToPresenter () {
    this.dialog.hide()
    store.setProfile('PRESENTER')
    this.$route.name !== 'presenter' && this.$router.replace('/presenter/')
  }

  goToAccount () {
    this.dialog.hide()
    this.$route.name !== 'account' && this.$router.replace('/account/')
  }

  signOut () {
    signOut()
  }
}
